
import { useState } from 'react';
import { pages as initialPages } from '../../../mocks/dashboardData';

export default function PagesSection() {
  const [pages, setPages] = useState(initialPages);
  const [showSuccess, setShowSuccess] = useState(false);

  const togglePublish = (id) => {
    setPages(pages.map(p => p.id === id ? {...p, isPublished: !p.isPublished} : p));
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  const getPageIcon = (path) => {
    const icons = {
      '/': 'ri-home-line',
      '/about': 'ri-information-line',
      '/stories': 'ri-book-open-line',
      '/volunteer': 'ri-hand-heart-line',
      '/resources': 'ri-folder-line',
      '/contact': 'ri-mail-line',
      '/donate': 'ri-heart-line',
    };
    return icons[path] || 'ri-file-line';
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Pages</h2>
          <p className="text-gray-600 text-sm">Manage your website pages</p>
        </div>
      </div>

      {showSuccess && (
        <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm flex items-center gap-2">
          <i className="ri-check-line"></i>
          Page status updated!
        </div>
      )}

      {/* Pages List */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="text-left px-6 py-4 text-sm font-semibold text-gray-900">Page</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-gray-900">URL Path</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-gray-900">Status</th>
                <th className="text-right px-6 py-4 text-sm font-semibold text-gray-900">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {pages.map((page) => (
                <tr key={page.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-[#6a4bc3]/10 rounded-lg flex items-center justify-center">
                        <i className={`${getPageIcon(page.path)} text-[#6a4bc3]`}></i>
                      </div>
                      <span className="font-medium text-gray-900">{page.name}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <code className="text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded">{page.path}</code>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => togglePublish(page.id)}
                      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium cursor-pointer ${
                        page.isPublished 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-gray-100 text-gray-600'
                      }`}
                    >
                      <span className={`w-1.5 h-1.5 rounded-full ${page.isPublished ? 'bg-green-500' : 'bg-gray-400'}`}></span>
                      {page.isPublished ? 'Published' : 'Draft'}
                    </button>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-end gap-2">
                      <a
                        href={page.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-[#6a4bc3] hover:bg-[#6a4bc3]/10 rounded-lg transition-colors cursor-pointer"
                        title="View Page"
                      >
                        <i className="ri-external-link-line"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="grid sm:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i className="ri-check-double-line text-green-600 text-xl"></i>
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{pages.filter(p => p.isPublished).length}</p>
              <p className="text-sm text-gray-500">Published Pages</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
              <i className="ri-draft-line text-gray-600 text-xl"></i>
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{pages.filter(p => !p.isPublished).length}</p>
              <p className="text-sm text-gray-500">Draft Pages</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
